import { useSyncExternalStore } from "react";

const REDUCED_MOTION_QUERY = "(prefers-reduced-motion: reduce)";

const getMediaQuery = () =>
	typeof window.matchMedia === "function" ? window.matchMedia(REDUCED_MOTION_QUERY) : undefined;

const subscribe = (onChange: () => void) => {
	const mediaQuery = getMediaQuery();
	mediaQuery?.addEventListener("change", onChange);

	return () => mediaQuery?.removeEventListener("change", onChange);
};

const getSnapshot = () => getMediaQuery()?.matches ?? false;

const getServerSnapshot = () => false;

/**
 * Whether the user asked the system to minimize animations. False on the server and until
 * hydration, then follows the setting live.
 */
export const usePrefersReducedMotion = () =>
	useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
